const APP_CONFIG = {
  API_URL: "https://be-monsi.binaglobalgroup.com/api/",
};

export default APP_CONFIG;
